import { Modal, Button, Group, Avatar, UnstyledButton } from "@mantine/core";
import { useState } from "react";

interface Props {
  opened: boolean;
  onClose: () => void;
  onSelect: (avatarPath: string) => void;
  currentAvatar?: string;
}

const AVATARS = Array.from({ length: 8 }, (_, i) => `/avatars/${i + 1}.png`);

const AvatarSelectionModal = ({
  opened,
  onClose,
  onSelect,
  currentAvatar,
}: Props) => {
  const [selectedAvatar, setSelectedAvatar] = useState<string>(
    currentAvatar || ""
  );

  const handleSave = () => {
    if (selectedAvatar) {
      onSelect(selectedAvatar);
      onClose();
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Select Profile Picture"
      centered
      size="md"
      zIndex={2300}
    >
      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-4 gap-4 p-4">
          {AVATARS.map((avatar) => (
            <UnstyledButton
              key={avatar}
              onClick={() => setSelectedAvatar(avatar)}
              className={`flex justify-center ${
                selectedAvatar === avatar ? "ring-4 ring-blue-500 rounded-full" : ""
              }`}
            >
              <Avatar
                src={avatar}
                size={80}
                radius="xl"
                style={{ cursor: "pointer" }}
              />
            </UnstyledButton>
          ))}
        </div>
        <Group position="right">
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button
            color="dark"
            onClick={handleSave}
            disabled={!selectedAvatar}
          >
            Save
          </Button>
        </Group>
      </div>
    </Modal>
  );
};

export default AvatarSelectionModal;
